import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
// import contactSagas from './contacts/saga';
// import notesSagas from './notes/saga';
// import todosSagas from './todos/saga';
// import cardsSagas from './card/saga';
// import youtubeSearchSagas from './youtubeSearch/sagas';
// import searchAdsSagas from './searchads/sagas'

export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    // contactSagas(),
    // notesSagas(),
    // todosSagas(),
    // cardsSagas(),
    // youtubeSearchSagas(),
    // searchAdsSagas()
  ]);
}



// WEBPACK FOOTER //
// ./src/redux/sagas.js